import api from "./Api";

class UsuarioEnderecoService {
  GetUsuarioEndereco(payload) {
    return api.get("/v1/usuarioendereco/" + payload).then((response) => {
      return response.data;
    });
  }

  PostUsuarioEndereco(payload) {
    return api.post("/v1/usuarioendereco/", payload).then((response) => {
      return response.data;
    });
  }

  PutUsuarioEndereco(payload) {
    return api.put("/v1/usuarioendereco/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteUsuarioEndereco(payload) {
    return api.delete("/v1/usuarioendereco/" + payload).then((response) => {
      return response.data;
    });
  }

  GetUsuarioEnderecoOData(payload) {
    return api.get("/OData/usuarioendereco" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new UsuarioEnderecoService();
